import { useState, useEffect } from 'react';
import { db } from '../data/storage';
import type { Settings, WeightUnit } from '../data/types';

export function useSettings() {
    const [settings, setSettings] = useState<Settings>({ weightUnit: 'grams' });
    const [loading, setLoading] = useState(true);

    const loadSettings = async () => {
        try {
            const data = await db.getSettings();
            setSettings(data);
        } catch (error) {
            console.error('Error loading settings:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadSettings();
    }, []);

    const updateWeightUnit = async (unit: WeightUnit) => {
        const newSettings = { ...settings, weightUnit: unit };
        await db.updateSettings(newSettings);
        setSettings(newSettings);
    };

    // Conversion helpers
    const gramsToOunces = (grams: number): number => {
        return grams * 0.035274;
    };

    const ouncesToGrams = (ounces: number): number => {
        return ounces / 0.035274;
    };

    const formatWeight = (grams: number): string => {
        if (settings.weightUnit === 'ounces') {
            return `${gramsToOunces(grams).toFixed(2)} oz`;
        }
        return `${grams}g`;
    };

    return {
        settings,
        loading,
        updateWeightUnit,
        formatWeight,
        gramsToOunces,
        ouncesToGrams,
    };
}